import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, NO_ERRORS_SCHEMA, Output, EventEmitter } from '@angular/core';
//import { RouterLink, RouterLinkActive } from '@angular/router';
//import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MulticheckFilterComponent } from '../filters/multicheck-filter/multicheck-filter.component';
import { CompositeFilterDescriptor, SortDescriptor, distinct, filterBy, orderBy, } from '@progress/kendo-data-query';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { Release } from '../models/models.lib';
import { LoggerService } from '../shared/logger.service';
import { GridDataResult, GridModule, KENDO_GRID, PageChangeEvent, PagerPosition, PagerType } from '@progress/kendo-angular-grid';
import { ReleaseService } from './release.service';
import { formatTextLink } from '../common/utils.lib';
import { defaultGridPageSize } from '../common/constants.lib';

@Component({
  selector: 'app-view-release',
  standalone: true,
  imports: [
    CommonModule,
    GridModule,
    LabelModule,
    LayoutModule
  ],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './view-release.component.html',
  styleUrl: './view-release.component.scss'
})
export class ViewReleaseComponent implements OnInit {
  @Input({ required: true }) set release(val: Release) {
    this._release = val;
  }
  get release(): Release | undefined {
    return this._release;
  };

  @Output() closeForm: EventEmitter<void> = new EventEmitter();

  private _release: Release | undefined;
  public filter: CompositeFilterDescriptor = { logic: "and", filters: [] };
  public rawData: any[] = [];
  public gridData: any[] = filterBy(this.rawData, this.filter);
  public sort: SortDescriptor[] = [{field: "id", dir: "desc"}];
  public pagerTypes = ["numeric", "input"];
  public type: PagerType = "numeric";
  public info = true;
  //public pageSizes = [5, 10, 25, 50, 100];
  public previousNext = false;
  public position: PagerPosition = "bottom";
  public pageSize = defaultGridPageSize;
  public skip = 0;
  public buttonCount = 0;
  public formatTextLink = formatTextLink;

  constructor(
     private logger: LoggerService,
     private releaseService: ReleaseService
   ) {

   }

   ngOnInit(): void {
    this.logger.debug('ngOnInit...');
    if (this.release && this.release.id) {
      this.releaseService.fetchReleaseDetails(this.release.id)
      .then(data => {
        if (data) {
          this.rawData = data;
          this.loadItems();
        } else {
          this.rawData = [];
          this.loadItems();
        }
      })
      .catch(err => {
        this.logger.error(`doDataRequest:error: `, err);
        //this.loading = false;
      });

    }

  }

  public sortChange(sort: SortDescriptor[]): void {
    this.logger.debug("sortChange: ", sort);
    this.sort = sort;
    this.loadItems();
    // this.fetchUserStories(this.selectedProject);
  }

  public filterChange(filter: CompositeFilterDescriptor): void {
    this.logger.debug('filterChange: filter: ', filter);
    this.filter = filter;
    this.loadItems();
    // this.fetchUserStories(this.selectedProject);
  }

  public distinctPrimitive(fieldName: string): any[] {
    // this.logger.debug('distinctPrimitive: fieldName: ', fieldName);
    return distinct(this.rawData, fieldName).map((item: any) => item[fieldName]);
    // return distinct(this.gridData, fieldName).map((item: any) => item[fieldName]);
  }

  private loadItems(): void {
    this.logger.debug(`loadItems: `)
    this.gridData = orderBy(filterBy(this.rawData, this.filter), this.sort);
    this.pageSize = this.gridData.length;

    //this.loading = false;
  }

  public onClose(): void {
    this.logger.debug(`onCancelAction...`);
    this.closeForm.emit();
   // this.dialog.close({ text: CasiCloseOptions.Cancelled });
  }

}
